import { apiFetch } from './utils/api';

export const accounts = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v2/accounts';
    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
